export default {"src":"/_next/static/media/buyer-guide.de108f0a.svg","height":396,"width":488,"blurWidth":0,"blurHeight":0};